import { render, staticRenderFns } from "./Closeds.vue?vue&type=template&id=665f42cf&scoped=true"
import script from "./Closeds.vue?vue&type=script&lang=js"
export * from "./Closeds.vue?vue&type=script&lang=js"
import style0 from "./Closeds.vue?vue&type=style&index=0&id=665f42cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f42cf",
  null
  
)

export default component.exports